import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthStateService } from '../../services/auth-state.service';
import * as FileSaver from 'file-saver';
import { AcModel } from '../../models/ac.model';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss']
})
export class FileListComponent implements OnInit, OnDestroy {

  public ac: AcModel = null;
  private acSubscription: Subscription = null;

  constructor(
    private data: DataService,
    private api: ApiService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

  public downloadFile(resource: ResourceModel): void {
    if (resource.hasRight(this.auth.getUserType())) {
      this.api
        .downloadFile(
          'template.file',
          this.ac.id,
          resource.id
        )
        .subscribe({
          next: (response: any) => {
            const blob = new Blob([response]);
            FileSaver.saveAs(blob, resource.public_name);
          }
        });
    }
  }

}
